@for (cal of duties; track cal.name) {
<div class="duty-group">
  <div class="duty-cal">{{ cal.name }}</div>
  <ul class="piquets-list">
    @for (e of cal.current; track e) {
    <li class="piquet-item">
      <div class="piquet-icon"><em class="fas fa-car-side"></em></div>
      <div class="piquet-content">
        <a [queryParams]="{ who: e.text }" class="piquet-name" routerLink="/annuaire">{{ e.text }}</a>
        <span class="piquet-meta">jusqu'au {{ e.endDate | date : 'd MMMM' }}</span>
      </div>
    </li>
    } @empty {
    <li class="piquet-item">
      <div class="piquet-icon piquet-icon--empty"><em class="fal fa-minus"></em></div>
      <div class="piquet-content">
        <span class="piquet-empty">Personne aujourd'hui</span>
      </div>
    </li>
    } @for (e of cal.next; track e) {
    <li class="piquet-item piquet-item--next">
      <div class="piquet-content">
        <a [queryParams]="{ who: e.text }" class="piquet-name" routerLink="/annuaire">{{ e.text }}</a>
        <span class="piquet-meta">{{ e.startDate | date : 'dd.MM' }} – {{ e.endDate | date : 'dd.MM' }}</span>
      </div>
    </li>
    }
  </ul>
</div>
}
